import { render } from "./WCItemModifierLinkedItem.vue?vue&type=template&id=3067a0bb&scoped=true"
import script from "./WCItemModifierLinkedItem.vue?vue&type=script&lang=js"
export * from "./WCItemModifierLinkedItem.vue?vue&type=script&lang=js"

import "./WCItemModifierLinkedItem.vue?vue&type=style&index=0&id=3067a0bb&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3067a0bb"]])

export default __exports__